import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { loadRuntime } from './config/runtime'
import { setRemBase } from './utils/rem'
import './styles/base.css'

// set rem base early (mobile-first, designWidth: 375)
setRemBase(375)

async function bootstrap() {
  await loadRuntime()
  const app = createApp(App)
  app.use(router)
  app.mount('#app')
}

bootstrap()
